module.exports = __webpack_public_path__ + "static/group.18403344.png";